<template>
	<div class="register_progress_callback_table">
		<div style="width: 800px;">
			<template>
			    <el-table
				    :data="tableData3"
				    :span-method="objectSpanMethod"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="RegModel"
							align="center"
					        width="200px">
							<template scope="scope">
					    		<div class="table_msg">	
					    			<div v-for="item in scope.row.code" class="table_msg_center">
					    				{{item}}
					    			</div>
					    		</div>
					    	</template>
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="RegRes（数组元素下标）">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			<div v-for="item in scope.row.msg" class="table_msg_list">
					    				{{item}}
					    			</div>
					    		</div>
					    	</template>
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				tableData3:[
					{
						"code":[
							"0",
							"(快速注册)",
						],
						"msg":[
							"0-17：右转头角度是否注册成功",
							"18-35：左转头角度是否注册成功",
							"36：正脸角度是否注册成功",
						],
					},
					{
						"code":[
							"1",
							"(标准注册)",
						],
						"msg":[
							"0-8：仰头角度是否注册成功",
							"9-17：右转头角度是否注册成功",
							"18-26：低头角度是否注册成功",
							"27-35：左转头角度是否注册成功",
							"36：正脸角度是否注册成功",
						],
					},
					{
						"code":[
							"2",
							"(精准注册)",
						],
						"msg":[
							"0-3：仰头角度是否注册成功",
							"4-8：右上方抬头角度是否注册成功",
							"9-12：右转头角度是否注册成功",
							"13-17：右下方低头角度是否注册成功",
							"18-21：低头角度是否注册成功",
							"22-26：左下方低头角度是否注册成功",
							"27-30：左转头角度是否注册成功",
							"31-35：左上方抬头角度是否注册成功",
							"36：正脸角度是否注册成功",
						],
					},
					{
						
						"msg":[
							'例如：',
							'使用“标准模式”进行注册，注册进度如下：',
							'“[0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]”',
							'数组0-8元素：仰头角度未注册成功',
							'数组9-17元素：右转头角度已注册成功',
							'数组18-26元素：低头角度未注册成功',
							'数组27-35元素：左转头角度已注册成功',
							'数组36元素：正脸角度已注册成功',
							'该字符串表示：',
							'标准注册模式下共注册5张图像，其中：仰头角度注册失败，右转头角度注册成功，低头角度注册失败，左转头角度注册成功，正脸注册成功。',

						],
						"rowspan":3,
						"colspan":3,
					},
				],
			}
		},
		methods:{
			objectSpanMethod({ row, column, rowIndex, columnIndex }){
				console.log(row, column, rowIndex, columnIndex)
				if (rowIndex === 3 ) {
			        // if (columnIndex === 1) {
			        //     return {
			        //       rowspan: row.rowspan,
			        //       colspan: row.colspan
			        //     };
			        // } else if (columnIndex === 0){
			        //     return {
			        //       rowspan: 0,
			        //       colspan: 0
			        //     };
			        // }
					if (columnIndex === 0) {
						return [0, 0];
					} else if (columnIndex === 1) {
						return [1, 2];
					}
		        }
			}
		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.table_msg_center {
		text-align: center;
	}
</style>	


// WEBPACK FOOTER //
// src/components/Registrationprogress.vue